import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { useEffect, useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import type { ScreenPropProvisionalRequestsOpen } from '~/navigation/Navigation.types';

import { SupportRequestItem } from '../SupportRequestItem';
import {
  ProvisionalRequestList,
  ProvisionalRequestListNative,
} from './ProvisionalRequest.List';

export const ProvisionalRequestsOpenScreen = (
  props: ScreenPropProvisionalRequestsOpen,
) => {
  return (
    <PageContainer>
      <ProvisionalRequestsLayout {...props} />
    </PageContainer>
  );
};

export const ProvisionalRequestsLayout = (props: ScreenPropProvisionalRequestsOpen) => {
  const supportRequestId = props.route.params?.id;
  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  useEffect(() => {
    setId(supportRequestId);
  }, [supportRequestId]);

  return (
    <ScreenTwoPageLayout>
      {isWeb ? (
        <ProvisionalRequestList onPress={(item) => setId(item.id)} id={id} />
      ) : (
        <ProvisionalRequestListNative />
      )}
      {id ? (
        <SupportRequestItem
          originScreen={'ProvisionalRequestsOpen'}
          supportId={id}
          onClose={() => setId(undefined)}
        />
      ) : (
        <></>
      )}
    </ScreenTwoPageLayout>
  );
};
